module.exports = __webpack_public_path__ + "img/daswarennochZeiten.007036db.jpg";